module.exports = __webpack_public_path__ + "static/media/step1.5aff2b09.png";